import { useState } from 'react';
import { List, Icon, Button } from 'semantic-ui-react';
import QuizResultsModal from './QuizResultsModal';

const UsersViewedTab = ({
  users,
  usersWhoRead,
  usersWhoHaventRead,
  loading,
  isQuiz,
  getQuizInteraction,
  entry,
}) => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedInteraction, setSelectedInteraction] = useState(null);
  const [quizResultsModalOpen, setQuizResultsModalOpen] = useState(false);

  // Filter users to only show assigned users or all if 'all' is in assigned_to
  const assignedTo = entry?.assigned_to || [];
  const assignedToArray = Array.isArray(assignedTo) ? assignedTo : [];
  const hasAll = assignedToArray.includes('all');

  // Filter users based on assignment
  const assignedUsers = hasAll ? users : users.filter((user) => assignedToArray.includes(user.id));

  // Filter usersWhoRead and usersWhoHaventRead to only show assigned users
  const assignedUsersWhoRead = assignedUsers.filter((user) =>
    usersWhoRead.some((readUser) => readUser.id === user.id)
  );
  const assignedUsersWhoHaventRead = assignedUsers.filter((user) =>
    usersWhoHaventRead.some((unreadUser) => unreadUser.id === user.id)
  );

  // Handle viewing quiz results
  const handleViewQuizResults = (user) => {
    const interaction = getQuizInteraction(user.id);
    if (interaction) {
      setSelectedUser(user);
      setSelectedInteraction(interaction);
      setQuizResultsModalOpen(true);
    }
  };

  return (
    <>
      <div style={{ marginBottom: '2rem' }}>
        <h3 style={{ marginBottom: '1rem' }}>
          <Icon name="check circle" color="green" />
          Visto ({assignedUsersWhoRead.length} de {assignedUsers.length})
        </h3>
        {loading ? (
          <p>Cargando usuarios...</p>
        ) : assignedUsersWhoRead.length > 0 ? (
          <List divided relaxed>
            {assignedUsersWhoRead.map((user) => {
              const quizInteraction = isQuiz ? getQuizInteraction(user.id) : null;
              return (
                <List.Item key={user.id}>
                  <List.Content>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '0.5rem',
                      }}
                    >
                      <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                        <List.Header>{user.name || 'Sin nombre'}</List.Header>
                        <List.Description>{user.email || 'Sin email'}</List.Description>
                      </div>
                      {isQuiz && quizInteraction && (
                        <Button
                          size="small"
                          icon="eye"
                          content="Ver resultados"
                          onClick={() => handleViewQuizResults(user)}
                          style={{ flexShrink: 0 }}
                        />
                      )}
                    </div>
                  </List.Content>
                </List.Item>
              );
            })}
          </List>
        ) : (
          <p style={{ color: '#999', fontStyle: 'italic' }}>
            Ningún usuario ha visto este contenido aún.
          </p>
        )}
      </div>

      <div>
        <h3 style={{ marginBottom: '1rem' }}>
          <Icon name="times circle" color="red" />
          No visto ({assignedUsersWhoHaventRead.length} de {assignedUsers.length})
        </h3>
        {loading ? (
          <p>Cargando usuarios...</p>
        ) : assignedUsersWhoHaventRead.length > 0 ? (
          <List divided relaxed>
            {assignedUsersWhoHaventRead.map((user) => {
              const quizInteraction = isQuiz ? getQuizInteraction(user.id) : null;
              return (
                <List.Item key={user.id}>
                  <List.Content>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '0.5rem',
                      }}
                    >
                      <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                        <List.Header>{user.name || 'Sin nombre'}</List.Header>
                        <List.Description>{user.email || 'Sin email'}</List.Description>
                      </div>
                      {isQuiz && quizInteraction && (
                        <Button
                          size="small"
                          icon="eye"
                          content="Ver resultados"
                          onClick={() => handleViewQuizResults(user)}
                          style={{ flexShrink: 0 }}
                        />
                      )}
                    </div>
                  </List.Content>
                </List.Item>
              );
            })}
          </List>
        ) : (
          <p style={{ color: '#999', fontStyle: 'italic' }}>
            Todos los usuarios han visto este contenido.
          </p>
        )}
      </div>

      <QuizResultsModal
        open={quizResultsModalOpen}
        onClose={() => {
          setQuizResultsModalOpen(false);
          setSelectedUser(null);
          setSelectedInteraction(null);
        }}
        user={selectedUser}
        entry={entry}
        interaction={selectedInteraction}
      />
    </>
  );
};

export default UsersViewedTab;
